import React from 'react';

interface ShapesSectionProps {
  onAddShapeElement: (shape: string) => void;
}

const ShapesSection: React.FC<ShapesSectionProps> = ({ onAddShapeElement }) => {
  const shapes = [
    {
      type: 'rectangle',
      name: 'Rectangle',
      icon: (
        <div className="w-8 h-6 bg-white rounded opacity-80"></div>
      ),
      bgColor: 'bg-blue-500',
      hoverColor: 'hover:bg-blue-600'
    },
    {
      type: 'circle',
      name: 'Circle',
      icon: (
        <div className="w-8 h-8 bg-white rounded-full opacity-80"></div>
      ),
      bgColor: 'bg-green-500',
      hoverColor: 'hover:bg-green-600'
    },
    {
      type: 'triangle',
      name: 'Triangle',
      icon: (
        <div className="w-0 h-0 border-l-4 border-r-4 border-b-8 border-l-transparent border-r-transparent border-b-white opacity-80"></div>
      ),
      bgColor: 'bg-purple-500',
      hoverColor: 'hover:bg-purple-600'
    },   
    {
      type: 'hexagon',
      name: 'Hexagon',
      icon: (
        <div className="w-6 h-6 bg-white clip-path-polygon-6 opacity-80"></div>
      ),
      bgColor: 'bg-teal-500',
      hoverColor: 'hover:bg-teal-600'
    }
  ];

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4 text-gray-800">Shapes</h3>
      <div className="grid grid-cols-3 gap-4">
        {shapes.map((shape) => (
          <div 
            key={shape.type}
            className={`w-16 h-12 ${shape.bgColor} rounded cursor-pointer ${shape.hoverColor} transition-colors flex items-center justify-center`}
            onClick={() => onAddShapeElement(shape.type)}
            title={shape.name}
          >
            {shape.icon}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShapesSection; 